import { QuantityBox } from './QuantityBox';

export default QuantityBox;
